<template>
  <div>
    <RfButtonNew
      type="quaternary"
      :disabled="disabled"
      class="border-beige-90 text-beige-90 fill-beige-90"
      @click="openTestEmailDialog"
    >
      <RfOpenInNewIcon class="h-6 w-6" /> Send Test Email
    </RfButtonNew>
    <v-dialog v-model="testEmailDialog" width="500">
      <v-card flat>
        <v-card-title class="headline">Enter Email Address</v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="testEmail"
            density="compact"
            hideDetails
            persistentPlaceholder
            variant="outlined"
            label="Recipient Email Address"
          />
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100"
            @click="closeTestEmailDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            size="large"
            variant="flat"
            color="accent"
            width="180"
            :disabled="!testEmail"
            @click="submitTestEmail"
          >
            Send Test Email
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { useLegacyLastErrorStore } from "@/pinia/legacyLastErrorStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useToastsStore } from "@/pinia/toastsStore";
import { computed } from "vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfOpenInNewIcon from "../icons/RfOpenInNewIcon.vue";

export default {
  name: "RfTestEmailSender",
  components: { RfButtonNew, RfOpenInNewIcon },
  props: ["path", "actionGroupId", "disabled"],
  setup: () => {
    const legacyLastErrorStore = useLegacyLastErrorStore();
    return {
      toastsStore: useToastsStore(),
      promptStore: usePromptStore(),
      lastError: computed(() => legacyLastErrorStore.lastError),
    };
  },
  data: () => ({ testEmail: null, testEmailDialog: false, sending: false }),
  watch: {
    lastError(to) {
      if (to && this.sending) {
        this.sending = false;
        this.toastsStore.create({ type: "error", body: to.message });
      }
    },
  },
  methods: {
    openTestEmailDialog() {
      this.testEmailDialog = true;
    },
    closeTestEmailDialog() {
      this.testEmailDialog = false;
    },
    submitTestEmail() {
      this.closeTestEmailDialog();
      const params = {
        appId: this.$route.params.aid,
        pathId: this.path.id,
        recipient: this.testEmail,
      };
      if (this.actionGroupId) params.actionGroupId = this.actionGroupId;
      this.sending = true;
      this.promptStore.sendTestEmail(params).then(() => {
        if (!this.lastError) {
          this.toastsStore.create({ type: "success", body: "Email sent. Please check your inbox" });
        }
      });

      this.sending = false;
    },
  },
};
</script>
